const cookie = require('browser-cookies')
const editor = {
  state: {
    dataList: [], //人员列表
    roleList: [], //角色列表
    oldRoleList: [], //上一次勾选的角色列表
    checkedIdList: [], // 人员选择勾选列表
    oldCheckedIdList: [], // 人员选择勾选列表
    itemId: '', //库id
    tag: {}, // 标签信息
    showPersonList: true, //选中库时无法配置权限
    showPreviewArticle: false,
    articleCreateRole: false,
    repoSysType: 'normal',
    isCompanyHasApp: false
  },
  mutations: {
    SET_DATA_LIST: (state, data) => {
      state.dataList = data
    },
    SET_ROLE_LIST: (state, data) => {
      state.roleList = data
    },
    SET_OLD_ROLE_LIST: (state, data) => {
      state.oldRoleList = data
    },
    SET_TAG: (state, data) => {
      state.tag = data
    },
    SET_SHOW_PERSON_LIST: (state, data) => {
      state.showPersonList = data
    },
    SET_ITEM_ID: (state, data) => {
      state.itemId = data
    },
    SET_PREVIEW_SHOW: (state, data) => {
      state.showPreviewArticle = data
    },
    //新建权限
    SET_CREATE_ROLE: (state, data) => {
      state.articleCreateRole = data
    },
    //库类型设置
    SET_SYS_TYPE: (state, data) => {
      state.repoSysType = data
    },
    //公司是否配置有资讯APP
    SET_COMPANY_HAS_APP: (state, data) => {
      state.isCompanyHasApp = data
    }
  },
  actions: {}
}

export default editor
